import * as React from "react";
const SvgYoutube = () => /* @__PURE__ */ React.createElement("svg", { width: 32, height: 32, fill: "none" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22.778 10.266a2.28 2.28 0 0 1 1.602 1.606c.378 1.416.378 4.372.378 4.372s0 2.956-.378 4.372a2.28 2.28 0 0 1-1.602 1.607c-1.413.378-7.079.378-7.079.378s-5.663 0-7.078-.378a2.28 2.28 0 0 1-1.603-1.607c-.377-1.416-.377-4.372-.377-4.372s0-2.956.377-4.372a2.28 2.28 0 0 1 1.603-1.606c1.415-.379 7.078-.379 7.078-.379s5.666 0 7.079.379m-4.182 5.978-4.707 2.725v-5.45z",
    clipRule: "evenodd"
  }
));
export default SvgYoutube;
